import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignDocument from "./pages/SignDocument";
import LandingPage from "./pages/LandingPage";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Landningssida */}
        <Route path="/" element={<LandingPage />} />

        {/* Signeringssida */}
        <Route path="/sign" element={<SignDocument />} />

        {/* Fallback för ogiltiga länkar */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
